<template>
	<div class="row principal">
		<div class="col-3 filtros">
			<b-form id="filtrosForm">
				<div class="row">
					<div class="col-12">
						<b-input-group size="sm" prepend="Fecha Desde">
							<date-picker id="fecha_desde" name="fecha_desde" v-model="fecha_desde"
								:config="{ format: 'DD/MM/YYYY', locale: 'es' }" placeholder="Ingresar Fecha" required>
							</date-picker>
						</b-input-group>
					</div>
				</div>
				<p></p>
				<div class="row">
					<div class="col-12">
						<b-input-group size="sm" prepend="Fecha Hasta">
							<date-picker id="fecha_hasta" name="fecha_hasta" v-model="fecha_hasta"
								:config="{ format: 'DD/MM/YYYY', locale: 'es' }" placeholder="Ingresar Fecha" required>
							</date-picker>
						</b-input-group>
					</div>
				</div>
				<p></p>
				<div class="row">
					<div class="col-12 text-right">
						<div v-if="!nodata" class="excel">
							<download-excel size="sm" :export-fields="campos" :data="documentos" :name="'reporte'"><i class="fas fa-file-excel fa-fw" /> Excel</download-excel>
						</div>&emsp;
						<b-button type="button" size="sm" variant="success" @click="ver()"><i class="fas fa-search fa-fw"></i> Ver</b-button>&nbsp;
					</div>
				</div>
			</b-form>
		</div>
		<div class="col-9">
			<div class="row tabla">
				<div class="col-12">
					<div class="row">
						<div class="col-3">
							<b-form-input size="sm" v-model="filtro" type="search" id="filterInput" placeholder="Búsqueda"></b-form-input>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-12">
							<b-table striped hover no-border-collapse head-variant="light" :filter="filtro" per-page="10" :current-page="currentPage" :items="getDocumentos" :fields="columnas">
								<template #cell(MONTO_NOTA_CREDITO_IVA)="data">
									{{ Intl.NumberFormat('es-CL').format(data.value) }}
								</template>
								<template #cell(MONTO_FACTURA_IVA)="data">
									{{ Intl.NumberFormat('es-CL').format(data.value) }}
								</template>
								<template #cell(MONTO_TOTAL)="data">
									{{ Intl.NumberFormat('es-CL').format(data.value) }}
								</template>
								<template #cell(MONTO_NOTA_CREDITO)="data">
									{{ Intl.NumberFormat('es-CL').format(data.value) }}
								</template>
								<template #cell(MONTO_FACTURA)="data">
									{{ Intl.NumberFormat('es-CL').format(data.value) }}
								</template>
								<template #cell(id_documentType)="data">
									{{ getBsale(data.value) }}
								</template>
								<template #cell(totalAmount)="data">
									{{ Intl.NumberFormat('es-CL').format(data.value) }}
								</template>
								<template #cell(FECHA_VENCIMIENTO)="data">
									{{ getFecha(data.value) }}
								</template>
								<template #cell(emissionDate)="data">
									{{ getFecha(data.value) }}
								</template>
								<template #cell(expirationDate)="data">
									{{ getFecha(data.value) }}
								</template>
							</b-table>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-12">
							<b-pagination v-model="currentPage" :total-rows="totalDoctos" per-page="10"></b-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import $ from "jquery"
	import DownloadExcel from "vue-json-excel"
	import bsale from "./../bsale.json"


	export default 
	{
		name: "Reporte",
		components: { DownloadExcel },
		props: {
			menu: String
		},
		data() {
			return {
				fecha_desde: "",
				fecha_hasta: "",
				nodata: true, // Flag que indica si la respuesta del ws trajo datos o no, para mostrar el mensaje en la pantalla
				mensaje: "",
				documentos: [], // Arreglo con el total de documentos del filtro
				filtro: "",
				currentPage: 1,
				columnas: [ 
					{ key: "id_documentType", label: "Document Type id", sortable: false, class: "text-nowrap" },
					{ key: "emissionDate", label: "Emission Date", sortable: false, class: "text-nowrap" },
					{ key: "expirationDate", label: "Expiration Date", sortable: false, class: "text-nowrap" },
					{ key: "code", label: "Code", sortable: false, class: "text-nowrap" },
					{ key: "client_id", label: "Cliente Id", sortable: false, class: "text-nowrap" },
					{ key: "client_id_madre", label: "Cliente Id Madre", sortable: false, class: "text-nowrap" },
					{ key: "company", label: "Company", sortable: false, class: "text-nowrap" },					
					{ key: "number", label: "Folio", sortable: false, class: "text-nowrap text-right" },	
					{ key: "fc_Folio", label: "FC Folio", sortable: false, class: "text-nowrap text-right" },					
					{ key: "MONTO_TOTAL", label: "Exento", sortable: false, class: "text-nowrap text-right" },					
					{ key: "netAmount", label: "Net Amount", sortable: false, class: "text-nowrap text-right" },
					{ key: "taxAmount", label: "IVA", sortable: false, class: "text-nowrap text-right" },					
					{ key: "totalAmount", label: "Total Amount", sortable: false, class: "text-nowrap text-right" },	
					{ key: "MONTO_NOTA_CREDITO", label: "Monto Nota Crédito", sortable: false, class: "text-nowrap text-right" },										
					{ key: "especial", label: "Especial", sortable: false, class: "text-nowrap" },
					{ key: "centro_costo", label: "Centro Costo", sortable: false, class: "text-nowrap" },
					{ key: "orden_compra", label: "Orden Compra", sortable: false, class: "text-nowrap" },
					{ key: "desglose", label: "Desglose", sortable: false, class: "text-nowrap" },
					{ key: "hes", label: "HES", sortable: false, class: "text-nowrap" },
					{ key: "CIUDAD_FAC", label: "Ciudad Fac", sortable: false, class: "text-nowrap" },
					{ key: "CLIENTE_CITY", label: "Cliente City", sortable: false, class: "text-nowrap" },
					{ key: "PAYMENT_TERMS", label: "Payment Terms", sortable: false, class: "text-nowrap" },
					{ key: "metodo_pago", label: "Método Pago", sortable: false, class: "text-nowrap" },
					{ key: "GIROS", label: "Giros", sortable: false, class: "text-nowrap" },
					{ key: "grupo_economico", label: "Grupo Económico", sortable: false, class: "text-nowrap" },
					{ key: "CLIENT_ADDRESS", label: "Client Address", sortable: false, class: "text-nowrap" },
					{ key: "nombre_admin", label: "Nombre Admin", sortable: false, class: "text-nowrap" },					
					{ key: "correo_admin", label: "Correo Admin", sortable: false, class: "text-nowrap" },
					{ key: "telefono_admin", label: "Teléfono Admin", sortable: false, class: "text-nowrap" },					
					{ key: "nombre_cob", label: "Nombre Cob", sortable: false, class: "text-nowrap" }, 					
					{ key: "correo_cob", label: "Correo Cob", sortable: false, class: "text-nowrap" },
					{ key: "telefono_cob", label: "Teléfono Cob", sortable: false, class: "text-nowrap" },										
					{ key: "CORREOS_FAC", label: "Correos Fac", sortable: false, class: "text-nowrap" },
					{ key: "sales_rep", label: "Sales Rep", sortable: false, class: "text-nowrap" },			
					{ key: "soporte", label: "Soporte", sortable: false, class: "text-nowrap text-right" },							
					{ key: "NOMINA", label: "Nómina", sortable: false, class: "text-nowrap" },	
					{ key: "MONTO_TOTAL", label: "Monto Total", sortable: false, class: "text-nowrap text-right" },					
					{ key: "CLIENTE_NAME", label: "Cliente Name", sortable: false, class: "text-nowrap" },					
					{ key: "categoria", label: "Categoría", sortable: false, class: "text-nowrap" },
					{ key: "Detalle_CC_Facturacion", label: "Detalle CC Facturación", sortable: false, class: "text-nowrap" },					

					
					{ key: "MONTO_NOTA_CREDITO_IVA", label: "Monto NC IVA", sortable: false, class: "text-nowrap text-right" },
					{ key: "tipo_of", label: "Tipo OF", sortable: false, class: "text-nowrap" },					
					{ key: "fl_facturado_iva", label: "FL Facturado IVA", sortable: false, class: "text-nowrap text-right" },															
					{ key: "recurrente", label: "Recurrente", sortable: false, class: "text-nowrap" },
					{ key: "vencimiento_oc", label: "Vencimiento OC", sortable: false, class: "text-nowrap" },
					{ key: "MONTO_FACTURA_IVA", label: "Monto Factura IVA", sortable: false, class: "text-nowrap text-right" },					
					{ key: "fl_ncEmitida_iva", label: "FL NC Emitida IVA", sortable: false, class: "text-nowrap text-right" },										
					{ key: "FECHA_VENCIMIENTO", label: "Fecha Vencimiento", sortable: false, class: "text-nowrap" },					
					{ key: "MONTO_FACTURA", label: "Monto Factura", sortable: false, class: "text-nowrap text-right" },										
					{ key: "n_oc", label: "N OCs", sortable: false, class: "text-nowrap" },
					{ key: "doc_ESid", label: "Doc ESid", sortable: false, class: "text-nowrap" },
					{ key: "id", label: "Id", sortable: false, class: "text-nowrap" },																													
					{ key: "ES_id_of", label: "ES Id Of", sortable: false, class: "text-nowrap" },					
					
				],
				campos: {
					"DOCUMENT TYPE ID": {
						field: "id_documentType",
						callback: (value) => { return this.getBsale(value); }
					},
					"EMISSION  DATE": {
						field: "emissionDate",
						callback: (value) => { return this.getFecha(value); }
					},
					"EXPIRATION DATE": {
						field: "expirationDate",
						callback: (value) => { return this.getFecha(value); }
					},
					"CODE": "code",
					"CLIENTE ID": "client_id",
					"CLIENTE ID MADRE": "client_id_madre",
					"COMPANY": "company",					
					"Folio": "number",	
					"FC FOLIO": "fc_Folio",					
					"EXENTO": "totalAmount",	
					"NET AMOUNT": "netAmount",
					"IVA": "taxAmount",					
					"TOTAL AMOUNT": "totalAmount",
					"MONTO NOTA CREDITO": "MONTO_NOTA_CREDITO",									
					"ESPECIAL": "especial",
					"CENTRO COSTO": "centro_costo",
					"ORDEN COMPRA": "orden_compra",
					"DESGLOSE": "desglose",
					"HES": "hes",
					"CIUDAD FAC": "CIUDAD_FAC",
					"CLIENTE CITY": "CLIENTE_CITY",
					"PAYMENT TERMS": "PAYMENT_TERMS",
					"METODO PAGO": "metodo_pago",
					"GIROS": "giros",
					"GRUPO ECONOMICO": "grupo_economico",
					"CLIENT ADDRESS": "CLIENT_ADDRESS",
					"NOMBRE ADMIN": "nombre_admin",
					"CORREO ADMIN": "correo_admin",
					"TELEFONO ADMIN": "telefono_admin",	
					"NOMBRE COB": "nombre_cob",	
					"CORREO COB": "correo_cob",
					"TELEFONO COB": "telefono_cob",	
					"CORREOS FAC": "CORREOS_FAC",	
					"SALES REP": "sales_rep",																		
					"SOPORTE": "soporte",	
					"NOMINA": "nomina",
					"MONTO TOTAL": "MONTO_TOTAL",	
					"CLIENTE NAME": "CLIENTE_NAME",	
					"CATEGORIA": "categoria",	
					"DETALLE CC FACTURACION": "Detalle_CC_Facturacion",					
					"MONTO NC IVA": "MONTO_NOTA_CREDITO_IVA",
					"TIPO OF": "tipo_of",					
					"FL FACTURADO IVA": "orden_compra",															
					"RECURRENTE": "recurrente",
					"VENCIMIENTO OC": "vencimiento_oc",
					"MONTO FACTURA IVA": "MONTO_FACTURA_IVA",									
					"FL NC EMITIDA IVA": "fl_ncEmitida_iva",					
					"FECHA VENCIMIENTO": {
						field: "FECHA_VENCIMIENTO",
						callback: (value) => { return this.getFecha(value); }
					},														
					"MONTO FACTURA": "MONTO_FACTURA",															
					"N OCs": "n_oc",					
					"DOC ESID": "doc_ESid",
					"ID": "id",																								
					"ES ID OF": "ES_id_of",										
				},
			}
		},
		computed: {

			getDocumentos() {

				return this.filtrar()
			},

			totalDoctos() {

				return this.filtrar().length
			}
		},
		methods: {

			filtrar() {

				return this.documentos.filter((documento) => {

					return documento.CLIENTE_NAME != undefined && documento.CLIENTE_NAME.toLowerCase().includes(this.filtro.toLowerCase())
				})
			},

			getBsale(id) {

				var name = id 
				bsale.forEach(function(docto) {

					if (docto.codigo == id)
					{
						name = docto.nombre
						return false
					}
				})

				return name
			},

			getFecha(unix) {

				return moment.unix(unix).utc().format("DD-MM-YYYY")
			},

            ver() {

				// Guardamos los datos del formulario para validacion
				var form = $("#filtrosForm")[0]
				var data = new FormData(form)

				// Flag que controla la validacion
				var seguir = false 

				// Recorremos todos los campos del formulario para validar que tengan datos
				// Si hay uno que no tenga dato, lo destacamos con un borde rojo (clase is-invalid)
				data.forEach(function(value, key, o) {

					var required = $("#" + key).attr("required")
					if (required != undefined && value == "") {

						$("#" + key).addClass("is-invalid")
						seguir = true
					} else
						$("#" + key).removeClass("is-invalid")
				})

				if (!seguir)
					this.buscar()
            },

            buscar() {

				// Ocultamos el panel con los dtos y mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				// Parseamos las fechas para transformarla al formato YYYY-MM-DD
				var tmp = this.fecha_desde.split("/")
				var fdesde = tmp[2] + "-" + tmp[1] + "-" + tmp[0]
				var desde = moment(fdesde).unix()

				tmp = this.fecha_hasta.split("/")
				var fhasta = tmp[2] + "-" + tmp[1] + "-" + tmp[0]
				var hasta = moment(fhasta).unix()

                // Llamamos al WS para traer las fichas a mostrar
				var request = { 
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "iF", 
					"operacion": "iF_emission", 
					"data2Query": {
						"fecha_de_desde": desde,
						"fecha_de_hasta": hasta
					}
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					// Chequeamos si existe la propiedad mensaje_error
					// Si existe es porque hubo un problema en la llamada o no hay datos y mostramos el mensaje
					var data = response.data
					if (data.estatus !== undefined && data.estatus == "OK") {

						this.nodata = false
						this.mensaje = ""
						this.documentos = response.data.data
					} else {

						this.nodata = true
						this.mensaje = data.mensaje_error
					}

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => { 

					// Si hubo un error, pasamos por aca
					console.log(ex.message) 

					// Ocultamos la imagen cargando y mostramos el panel con los datos
					window.event.$emit("mostrar-cargando", false)
				})
            }
		}
	}

</script>
<style scoped>

	.principal {
		width: 100%;
		height: 550px;
		margin: 0 !important;
	}

	.filtros {
        width: 100%;
		height: 100%;
		padding: 10px;
	}

	.excel {
		display: inline-block;
		padding: 5px 10px 5px 10px;
		background-color: black;
		color: white;
		border-radius: 4px;
	}

	.excel:hover {
		cursor: pointer;
		opacity: 0.5;
	}

    .tabla {
		height: 100%;
        overflow: auto;
        background-color: white;
		padding: 10px 0px 10px 0px;
		margin-top: 10px !important;
		margin-right: -5px !important;
    }

</style>
